import _regeneratorRuntime from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ChatSession from "./ChatSession";
import ConversationSession from "./ConversationSession";
import ConversationSessionAsync from "./ConversationSessionAsync";
import GlobalPresenceSession from "./GlobalPresenceSession";
import * as log from "loglevel";

var ChatManager = /*#__PURE__*/function () {
  function ChatManager() {
    _classCallCheck(this, ChatManager);

    this.chatSessions = {};
    this.conversationSessions = {};
    this.globalPresenceSessions = {};
  }

  _createClass(ChatManager, [{
    key: "init",
    value: function init(restApiURL, partnerName, logLevel) {
      this._restApiURL = restApiURL;
      this._partnerName = partnerName;

      if (logLevel) {
        this._logLevel = logLevel;
      } else {
        this._logLevel = "warn";
      }

      log.setLevel(this._logLevel);
    }
  }, {
    key: "getAPIRoomsURL",
    value: function getAPIRoomsURL() {
      return this.restApiURL + "/rooms";
    }
  }, {
    key: "getAPISpecificRoomURL",
    value: function getAPISpecificRoomURL(roomName) {
      return this.restApiURL + "/rooms/" + roomName;
    }
  }, {
    key: "getAPIRequestAccessTokenURL",
    value: function getAPIRequestAccessTokenURL() {
      return this.restApiURL + "/auth/roomTokens";
    }
  }, {
    key: "getAPIIsRoomOnlineURL",
    value: function getAPIIsRoomOnlineURL(roomName) {
      return this.getAPIRoomsURL() + "/" + roomName;
    }
  }, {
    key: "registerSession",
    value: function registerSession(chatSession) {
      this.chatSessions[chatSession.id] = chatSession;
    }
  }, {
    key: "getChatSession",
    value: function getChatSession(chatSessionId) {
      return this.chatSessions[chatSessionId];
    }
  }, {
    key: "registerConversationSession",
    value: function registerConversationSession(conversationSession) {
      this.conversationSessions[conversationSession.id] = conversationSession;
    }
  }, {
    key: "registerGlobalPresenceSession",
    value: function registerGlobalPresenceSession(globalPresenceSession) {
      this.globalPresenceSessions[globalPresenceSession.id] = globalPresenceSession;
    }
  }, {
    key: "getConversationSession",
    value: function getConversationSession(conversationSessionId) {
      return this.conversationSessions[conversationSessionId];
    }
  }, {
    key: "getGlobalPresenceSession",
    value: function getGlobalPresenceSession(sessionId) {
      return this.globalPresenceSessions[sessionId];
    }
  }, {
    key: "createGlobalPresenceSession",
    value: function createGlobalPresenceSession(userName, accessToken, createGlobalPresenceSessionHandler) {
      var _this = this;

      var createGlobalPresenceSession = new GlobalPresenceSession(userName, accessToken);
      createGlobalPresenceSession.requestFirebaseAccess(function (createGlobalPresenceSession2, error) {
        if (!error) {
          _this.registerGlobalPresenceSession(createGlobalPresenceSession2);
        }

        if (createGlobalPresenceSessionHandler !== void 0) {
          createGlobalPresenceSessionHandler(createGlobalPresenceSession2, error);
        }
      });
      return createGlobalPresenceSession;
    }
  }, {
    key: "createConversationSession",
    value: function createConversationSession(userName, conversationName, accessToken, createConversationSessionHandler) {
      var _this2 = this;

      var conversationSession = new ConversationSession(userName, conversationName, accessToken);
      conversationSession.requestFirebaseAccess(function (conversationSession2, error) {
        if (!error) {
          _this2.registerConversationSession(conversationSession2);
        }

        if (createConversationSessionHandler !== void 0) {
          createConversationSessionHandler(conversationSession2, error);
        }
      });
      return conversationSession;
    }
  }, {
    key: "createConversationSessionAsyncWithoutListener",
    value: function createConversationSessionAsyncWithoutListener(userName, conversationName, accessToken, createConversationSessionHandler) {
      var conversationSession = new ConversationSessionAsync(userName, conversationName, accessToken);
      this.registerConversationSession(conversationSession);

      if (createConversationSessionHandler !== void 0) {
        createConversationSessionHandler(conversationSession);
      }

      return conversationSession;
    }
  }, {
    key: "createSession",
    value: function createSession(userName, roomName, accessToken, createSessionHandler) {
      var _this3 = this;

      var chatSession = new ChatSession(userName, roomName, accessToken);
      chatSession.requestFirebaseAccess(function (chatSession2, error) {
        if (!error) {
          _this3.registerSession(chatSession2);
        }

        if (createSessionHandler !== void 0) {
          createSessionHandler(chatSession2, error);
        }
      });
      return chatSession;
    }
  }, {
    key: "createSessionAsync",
    value: function () {
      var _createSessionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userName, roomName, accessToken, firebaseCredentials) {
        var chatSession, _yield$chatSession$re, data, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                chatSession = new ChatSession(userName, roomName, accessToken);
                _context.next = 3;
                return chatSession.requestFirebaseAccessAsync(firebaseCredentials);

              case 3:
                _yield$chatSession$re = _context.sent;
                data = _yield$chatSession$re.data;
                error = _yield$chatSession$re.error;

                if (error) {
                  _context.next = 9;
                  break;
                }

                this.registerSession(data);
                return _context.abrupt("return", {
                  data: data
                });

              case 9:
                return _context.abrupt("return", {
                  error: error
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createSessionAsync(_x, _x2, _x3, _x4) {
        return _createSessionAsync.apply(this, arguments);
      }

      return createSessionAsync;
    }()
  }, {
    key: "checkRoomOnline",
    value: function checkRoomOnline(roomName, accessToken, checkRoomOnlineHandler) {
      fetch(this.getAPIIsRoomOnlineURL(roomName), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + accessToken
        }
      }).then(function (response) {
        if (response.status === 200) {
          checkRoomOnlineHandler({
            online: true
          });
          return;
        }

        if (response.status === 404) {
          checkRoomOnlineHandler({
            online: false
          });
          return;
        }

        checkRoomOnlineHandler(void 0, "error calling check room online!");
      }).catch(function (error) {
        checkRoomOnlineHandler(void 0, error);
      });
    }
  }, {
    key: "restApiURL",
    get: function get() {
      return this._restApiURL;
    }
  }, {
    key: "partnerName",
    get: function get() {
      return this._partnerName;
    }
  }, {
    key: "logLevel",
    get: function get() {
      return this._logLevel;
    }
  }]);

  return ChatManager;
}();

var ChatManager_default = new ChatManager();
export { ChatManager_default as default };